// extracted by mini-css-extract-plugin
export default {"container":"styles_container__x0B4r","content":"styles_content__PnyPw"};